import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Stack, Box, Typography} from 'views/components';
import {Avatar} from 'views/module';
import {Link, Popover} from 'views/components';

import {Translate} from 'views/module';

const NotificationPopover = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const targetRef = React.useRef();

  const setOnClick = props.setOnClick;

  React.useEffect(() => {
    setAnchorEl(targetRef.current);
  }, [targetRef]);

  return (
    <>
      <Box
        sx={{
          textDecorationThickness: '2px',
          float: 'right',
          color: 'navbar.text',
        }}
        ref={targetRef}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="9" fill="none" viewBox="0 0 7 9">
          <path fill="currentColor" d="M7 4.5.25 8.397V.603L7 4.5Z"/>
        </svg>
      </Box>
      {
        anchorEl &&
        <Popover
          id="mouse-over-popover"
          sx={{
            pointerEvents: 'none',
          }}
          open={ true}
          anchorEl={anchorEl}
          anchorReference="anchorPosition"
          anchorPosition={{
            top: anchorEl.getBoundingClientRect().top - 16,
            left: anchorEl.getBoundingClientRect().right,
          }}
          PaperProps={{
            elevation: 0,
            sx: {
              borderRadius: '0px 4px 4px 0px',
            },
          }}
          onClose={() => setOnClick(false)}
          disableScrollLock
        >
          <Box
            sx={{
              backgroundColor: 'navbar.main',
              pointerEvents: 'auto',
              width: '200px',
            }}
            onClick={() => setOnClick(true)}
          >
            <Link
              href={'/signout'}
              sx={{
                'textDecoration': 'none',
                '&:hover': {
                  textDecoration: 'none',
                },
              }}
            >
              <Typography
                sx={{
                  'color': 'navbar.text',
                  'py': '8px',
                  'pl': '16px',
                  '&:hover': {
                    'backgroundColor': 'background.highlighted',
                    'borderRadius': '6px',
                  },
                }}
              >
                <Translate expression={'navbar.SignOut'} />
              </Typography>
            </Link>
          </Box>
        </Popover>
      }
    </>
  );
};
NotificationPopover.propTypes = {
  setOnClick: PropTypes.func,
};

const NavbarUser = (props) => {
  const [mouseOver, setMouseOver] = React.useState(false);
  const [onClick, setOnClick] = React.useState(false);

  const user = props.user;

  const showDetails = mouseOver && !onClick;

  return (
    <Stack
      direction="row"
      sx={{
        pl: 2,
        py: 1,
        alignItems: 'center',
        backgroundColor: mouseOver ? 'background.highlighted' : 'transparent',
        borderRadius: '8px',
      }}
      onMouseEnter={() => setMouseOver(true) & setOnClick(false)}
      onMouseLeave={() => setMouseOver(false)}
    >
      <Avatar
        resourceRn={user.userRn}
        sx={{
          width: '30px',
          height: '30px',
          fontSize: '16px',
          overflow: 'hidden',
        }}
        detail={{
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
        }}
      />
      <Box
        sx={{
          ml: '16px',
          width: '100%',
        }}
      >
        <Typography variant='h5'
          sx={{
            color: 'navbar.text',
            fontWeight: 500,
            fontSize: '14px',
            display: 'inline-block',
            width: '90%',
          }}>
          {user.firstName} {user.lastName}
        </Typography>
        {
          showDetails &&
          <NotificationPopover
            setOnClick={setOnClick}
          />
        }
      </Box>
    </Stack>
  );
};
NavbarUser.propTypes = {
  user: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarUser));
